<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Program
    </button>

    <a-modal v-model="visible" title="Add New Tuition Program" :footer="null">
      <a-form :form="form" @submit="handleSubmit">
        <div class="row">
          <div class="col-12 col-md-8">
            <a-form-item label="Program Name">
              <a-input
                placeholder="e.g. NEET Preparation"
                v-decorator="['name', { rules: [{ required: true, message: 'Please input program name!' }] }]"
              />
            </a-form-item>
          </div>

          <div class="col-12 col-md-4">
            <a-form-item label="Code">
              <a-input
                placeholder="e.g. NEET"
                v-decorator="['code', { rules: [{ required: true, message: 'Please input program code!' }] }]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="mb-2">
          <a-form-item label="Description">
            <a-textarea
              placeholder="Program description..."
              :autosize="{ minRows: 2 }"
              v-decorator="['description']"
            />
          </a-form-item>
        </div>

        <div>
          <a-form-item label="Status">
            <a-select v-decorator="['status', { initialValue: 1 }]">
              <a-select-option :value="1">Active</a-select-option>
              <a-select-option :value="0">Inactive</a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="text-right mt-4">
          <a-button class="mr-2" @click="handleCancel">Cancel</a-button>
          <a-button type="primary" html-type="submit" :loading="loading">Save Program</a-button>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AddTuitionProgramModal',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: 'Click OK to add this program to the tuition list.',
            onOk: () => {
              this.loading = true
              this.$nprogress.start()
              this.$http
                .post('/api/tuition/programs', values)
                .then(() => {
                  this.loading = false
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification.success({
                    message: 'Success!',
                    description: `Program "${values.name}" created successfully.`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
          })
        }
      })
    },
  },
}
</script>
